import { AxiosError } from 'axios'
import { ApiErrorResponse } from './types'

export function getApiErrorResponse(error: AxiosError<ApiErrorResponse>): ApiErrorResponse {
  if (error.response && error.response.data) {
    return error.response.data
  }

  return {
    code: '',
    message: '',
    timestamp: new Date().toISOString()
  }
}
